// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Share_Wrapper__3aVLK","Title":"Share_Title__1Bt4g","Inner":"Share_Inner__1Oj68","Link":"Share_Link__3S0kw"};